import { VillageRegion } from '@/types/Villa';

export default function villagesCatalogRequestUrl({
  offset,
  currency,
  searchParams,
  catalogId,
  region,
  limit = 9,
}: {
  offset?: number;
  currency?: string;
  searchParams?: { [key: string]: string | string[] | undefined };
  catalogId?: string;
  region?: VillageRegion;
  limit?: number;
}) {
  const offsetQuery = `&offset=${offset}`;
  const currencyQuery = `&currency=${currency}`;

  let url =
    process.env.API_URL +
    `/villas?filters%5BcurrentYear%5D=true&filters%5Benabled%5D=true&filters%5BcomputePrices%5D=1&limit=${limit}`;

  if (!searchParams?.sleeps && !searchParams?.location) {
    if (catalogId) {
      url = `${url}&serializerGroups%5B0%5D=group-villa`;
    } else {
      url = `${url}&orderBy%5Bpriority%5D=ASC&orderBy%5Bid%5D=DESC&serializerGroups%5B0%5D=group-villa`;
    }
  }

  if (!searchParams?.q && !catalogId && !searchParams?.location) {
    url = `${url}&filters%5Bregion%5D=${region ?? VillageRegion.Sicily}`;
  }

  if (offset) {
    url = `${url}${offsetQuery}`;
  }

  if (currency && currency !== 'eur') {
    url = `${url}${currencyQuery}`;
  }

  if (catalogId) {
    url = `${url}&filters%5Bcatalogs%5D=${catalogId}`;
  }

  if (searchParams) {
    if (searchParams.location) {
      url = `${url}&filters%5Bzone%5D=${searchParams.location}`;
    }
    if (searchParams.sleeps) {
      url = `${url}&filters%5Bsleeps%5D=${searchParams.sleeps}&filters%5Benabled%5D=true&orderBy%5Bsleeps%5D=ASC&orderBy%5Bid%5D=ASC`;
    }
    if (searchParams.startDate && searchParams.endDate) {
      url = `${url}&filters%5BdateRange%5D%5Bstart%5D=${searchParams.startDate}&filters%5BdateRange%5D%5Bend%5D=${searchParams.endDate}`;
    }
    if (searchParams.adults) {
      url = `${url}&filters%5Badults%5D=${searchParams.adults}`;
    }
    if (searchParams.children) {
      url = `${url}&filters%5Bchildren%5D=${searchParams.children}`;
    }
    if (searchParams.infants) {
      url = `${url}&filters%5Binfants%5D=${searchParams.infants}`;
    }
    if (searchParams.q) {
      url = `${url}&filters%5Bsleeps%5D=0&filters%5Blike%5D%5Btitle%5D=${searchParams.q}`;
    }
  }

  return url;
}
